const MainContent = ({ children }) => {
  return <main className="main">{children}</main>;
};

export default MainContent;
